/* eslint-disable @typescript-eslint/quotes */
import { Component, NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { ReportsComponent } from "./secure/reports/reports.component";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { UserListComponent } from "./secure/master/user/list/user-list.component";
import { UserAUComponent } from "./secure/master/user/au/user-au.component";
import { RoleListComponent } from "./secure/master/role/list/role-list.component";
import { RoleAUComponent } from "./secure/master/role/au/role-au.component";
import { OrganizationAUComponent } from "./secure/master/organization/au/organization-au.component";
import { OrganizationListComponent } from "./secure/master/organization/list/organization-list.component";
import { FeatureListComponent } from "./secure/master/feature/list/feature-list.component";
import { FeatureAUComponent } from "./secure/master/feature/au/feature-au.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { ReactiveFormsModule } from "@angular/forms";
import { AnnouncementListComponent } from "./secure/announcement/list/announcement-list.component";
import { AnnouncementAuComponent } from "./secure/announcement/au/announcement-au.component";
import { QueryExecutorListComponent } from "./secure/query-executor-list/query-executor-list.component";
import { QueryExecutorComponent } from "./secure/query-executor/query-executor.component";
import { FullCalendarComponent } from "./full-calendar/full-calendar.component";
import { HomeComponent } from "./secure/home/home.component";
import { OpenAppointmentTableComponent } from "./secure/open-appintment-slot/table/open-appointment-table.component";
import { ViewApplicantAppoitmentDtlComponent } from "./secure/apointment-list/view/applicant-appointment-dtl.component";
import { apointmentComponent } from "./secure/apointment-list/apointment.component";
import { AppointmentAuditTrailComponent } from "./secure/appointment-auditTrail/appointmentAudit-trail.component";
import { OpenAppointmentSlot } from "./secure/open-appintment-slot/open-appointment-slot.component";
import { TimePickerComponent } from "./secure/timePikker/time-picker.component";
import { VisitorDashboardComponent } from "./secure/visitorDashboard/visitorDashboard.component";
import { visitorDashboardcopycopyComponent } from "./secure/visitorDashboardcopycopy/visitorDashboardcopycopy.component";
import { ChangePasswordComponent } from "./secure/change-password/change-password.component";
import { WalkinAppointmentComponent } from "./secure/walkin-appointment/walkin-appointment.component";
import { WalkinAppointmentListComponent } from "./secure/walkin-appointment-list/walkin-appointment-list.component";
import { helpfileComponent } from "./secure/help-file/help-file.component";
import { NewvisitorDashboardComponent } from "./secure/NewvisitorDashboard/NewvisitorDashboard.component";

const routes: Routes = [
  { path: "", component: LoginComponent },
  {
    path: "secure",
    component: SidenavComponent,
    children: [
      { path: "home", component: HomeComponent },
      { path: "full-calendar", component: FullCalendarComponent },
      
      { path: "apointmentList", component: apointmentComponent },
      {
        path: "applicant-appointment-dtl/:appointmentId/:appointmentStatus",
        component: ViewApplicantAppoitmentDtlComponent,
      },
      {
      path: "open-appintment-slot/table",
      component: OpenAppointmentTableComponent,
    },
    {
      path: "open-appintment-slot",
      component: OpenAppointmentSlot,
    },
    {
      path: "open-appintment-slot/:key",
      component: OpenAppointmentSlot,
    },
    {
      path: "appointment-auditTrail",
      component: AppointmentAuditTrailComponent,
    },
    {
      path: "visitor-dashboard",
      component: VisitorDashboardComponent,
    },
    {
      path: "New_visitor-dashboard",
      component: NewvisitorDashboardComponent,
    },
    {
      path: "visitor-dashboardcopycopy",
      component: visitorDashboardcopycopyComponent,
    },
    {
      path: "walkin-appointment-book",
      component: WalkinAppointmentComponent,
    },
    {
      path: "walkin-appointment-list",
      component: WalkinAppointmentListComponent,
    },
    {
      path: "help-file",
      component: helpfileComponent,
    },
    
      { path: "announcement/list", component: AnnouncementListComponent },
      { path: "announcement/au", component: AnnouncementAuComponent },
      { path: "announcement/au/:key", component: AnnouncementAuComponent },
      { path: "timePikker", component: TimePickerComponent },
      { path: "change-password", component: ChangePasswordComponent },

      {
        path: "master",
        children: [
          { path: "user/list", component: UserListComponent },
          { path: "user/au", component: UserAUComponent },
          { path: "user/au/:key", component: UserAUComponent },
          { path: "role/list", component: RoleListComponent },
          { path: "role/au", component: RoleAUComponent },
          { path: "role/au/:key", component: RoleAUComponent },
          { path: "feature/list", component: FeatureListComponent },
          { path: "feature/au", component: FeatureAUComponent },
          { path: "feature/au/:key", component: FeatureAUComponent },
          { path: "organization/list", component: OrganizationListComponent },
          { path: "organization/au", component: OrganizationAUComponent },
          { path: "organization/au/:key", component: OrganizationAUComponent },
        ],
      },
      { path: "query-executor-list", component: QueryExecutorListComponent },
      { path: "reports", component: ReportsComponent },
      { path: "query-executor", component: QueryExecutorComponent },
      { path: "query-executor/:key", component: QueryExecutorComponent },
    ],
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    NgMultiSelectDropDownModule.forRoot(),
    ReactiveFormsModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
